import { create } from "zustand";

export const useChatStore = create((set) => ({
  conversations: {},
  sources: {}, // domainId -> [sources]

  setMessages: (domainId, messages) =>
    set((state) => ({
      conversations: {
        ...state.conversations,
        [domainId]: messages,
      },
    })),

  appendMessage: (domainId, message) =>
    set((state) => {
      const existing = state.conversations[domainId] || [];
      return {
        conversations: {
          ...state.conversations,
          [domainId]: [...existing, message],
        },
      };
    }),

  updateLastMessage: (domainId, content, sources = null) =>
    set((state) => {
      const existing = state.conversations[domainId] || [];
      if (existing.length === 0) return state;
      const updated = [...existing];
      updated[updated.length - 1] = { ...updated[updated.length - 1], content };
      const result = {
        conversations: {
          ...state.conversations,
          [domainId]: updated,
        },
      };
      if (sources !== null) {
        result.sources = { ...state.sources, [domainId]: sources };
      }
      return result;
    }),

  setSources: (domainId, sources) =>
    set((state) => ({
      sources: {
        ...state.sources,
        [domainId]: sources,
      },
    })),

  clearConversation: (domainId) =>
    set((state) => {
      const { [domainId]: _, ...restConv } = state.conversations;
      const { [domainId]: __, ...restSources } = state.sources;
      return { conversations: restConv, sources: restSources };
    }),
}));
